import { EventsRepository } from 'common/repositories/index';
import eventManager from 'common/services/-RFC.eventManager';

/**
 * Listen events for Events Model
 */
angular.module('listeners')
    .service('EventsListener', () => {

        eventManager.subscribe('socket:events', (response) => {

            if (response.verb === 'POST') {

                EventsRepository.add(response.payload.data);

            }

        });

    });



// WEBPACK FOOTER //
// ./scripts/common/listeners/event.js